<kt-portlet>
  <kt-portlet-header [class]="'card-head-lg'" style="box-shadow: unset">
    <ng-container ktPortletTitle>
      <span>Notification list</span>
    </ng-container>
    <ng-container ktPortletTools> </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div
      class="mat-table-wrapper"
      style="overflow-x: hidden; overflow-y: scroll; max-height: 300px"
    >
      <mat-table
        class="lmat-elevation-z8"
        #table
        [dataSource]="dataSource"
        matSort
        #sort1="matSort"
        matSortActive="id"
        matSortDirection="desc"
        matSortDisableClearstyle="min-width: unset"
      >
        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef>{{ 'Description' }} </mat-header-cell>
          <mat-cell *matCellDef="let notification">{{ notification.description }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="source">
          <mat-header-cell *matHeaderCellDef>{{ 'Source' }} </mat-header-cell>
          <mat-cell *matCellDef="let notification">{{ notification.source }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="channels">
          <mat-header-cell *matHeaderCellDef>{{ 'Channels' }} </mat-header-cell>
          <mat-cell *matCellDef="let notification">
            <div style="width: 180px; word-wrap: break-word">
              <span
                class="pr-1 pl-1 text-success entity-name"
                *ngFor="let channel of notification.channels as channels; let i = index"
                [class.border-right]="i !== channels.length - 1"
                >{{ channel.name }}
              </span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>{{ 'Status' }} </mat-header-cell>
          <mat-cell *matCellDef="let notification">
            <span
              class="label label-lg label-light-{{
                getItemCssClassByStatus(notification.is_active)
              }} label-inline"
            >
              {{ getItemStatusString(notification.is_active) }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef>{{ 'Actions' }} </mat-header-cell>
          <mat-cell *matCellDef="let notification" class="clickable">
            <button
              color="primary"
              matTooltip="Edit Notification"
              (click)="updateCompanyNotification(notification)"
              class="btn btn-icon btn-light btn-hover-primary btn-sm margin-2"
            >
              <span class="svg-icon svg-icon-md svg-icon-primary">
                <span inlineSVG="./assets/media/svg/icons/General/edit_icon.svg"></span>
              </span>
            </button>
            &nbsp;
            <!--            <button color="danger" matTooltip="Delete Office" (click)="deleteCompanyNotification(notification)" class="btn btn-icon btn-light btn-hover-danger btn-sm margin-2">-->
            <!--                <span class="svg-icon svg-icon-md svg-icon-danger">-->
            <!--                  <span inlineSVG="./assets/media/svg/icons/General/delete_icon.svg"></span>-->
            <!--                </span>-->
            <!--            </button>-->
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table__message" *ngIf="!dataSource.hasItems">
        {{ 'TABLE.NO_RECORDS' | translate }}
      </div>
      <div class="mat-table__message" *ngIf="dataSource.isPreloadTextViewed$ | async">
        {{ 'TABLE.PLAESE_WAIT' | translate }}
      </div>
    </div>

    <div class="mat-table__bottom background-white">
      <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-body>
</kt-portlet>
